import React from "react";

const NavigationSVG = () => {
  return (
    <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="1" y="1" width="46" height="46" rx="23" fill="#FAFAFA" />
    <mask
      id="mask0_3248_58462"
      style={{maskType:"alpha"}}
      maskUnits="userSpaceOnUse"
      x="8"
      y="8"
      width="32"
      height="32"
    >
      <rect x="8" y="8" width="32" height="32" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_3248_58462)">
      <path
        d="M24 28.7673C23.8223 28.7673 23.6556 28.7393 23.5 28.6833C23.3445 28.6282 23.2 28.534 23.0667 28.4007L18.2667 23.6006C18.0223 23.3562 17.9 23.0451 17.9 22.6673C17.9 22.2895 18.0223 21.9784 18.2667 21.734C18.5112 21.4895 18.8276 21.3615 19.216 21.35C19.6054 21.3393 19.9223 21.4562 20.1667 21.7007L22.6667 24.2007V14.6673C22.6667 14.2895 22.7947 13.9727 23.0507 13.7167C23.3058 13.4615 23.6223 13.334 24 13.334C24.3778 13.334 24.6947 13.4615 24.9507 13.7167C25.2058 13.9727 25.3334 14.2895 25.3334 14.6673V24.2007L27.8334 21.7007C28.0778 21.4562 28.3947 21.3393 28.784 21.35C29.1725 21.3615 29.4889 21.4895 29.7334 21.734C29.9778 21.9784 30.1 22.2895 30.1 22.6673C30.1 23.0451 29.9778 23.3562 29.7334 23.6006L24.9334 28.4007C24.8 28.534 24.6556 28.6282 24.5 28.6833C24.3445 28.7393 24.1778 28.7673 24 28.7673ZM16 34.6673C15.2667 34.6673 14.6392 34.4064 14.1174 33.8846C13.5947 33.362 13.3334 32.734 13.3334 32.0007V29.334C13.3334 28.9562 13.4609 28.6393 13.716 28.3833C13.972 28.1282 14.2889 28.0007 14.6667 28.0007C15.0445 28.0007 15.3614 28.1282 15.6174 28.3833C15.8725 28.6393 16 28.9562 16 29.334V32.0007H32V29.334C32 28.9562 32.128 28.6393 32.384 28.3833C32.6392 28.1282 32.9556 28.0007 33.3334 28.0007C33.7112 28.0007 34.0276 28.1282 34.2827 28.3833C34.5387 28.6393 34.6667 28.9562 34.6667 29.334V32.0007C34.6667 32.734 34.4058 33.362 33.884 33.8846C33.3614 34.4064 32.7334 34.6673 32 34.6673H16Z"
        fill="#212121"
      />
    </g>

  </svg>
  );
};

export default NavigationSVG;
